import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { DatePickerFormControl } from "../Web/DatePickerFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers";
import { LabelFormControl } from "../Web/LabelFormControl";
import { TextControlSize, TextControlStyle } from "../../Utilities/FormDesignConstants";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col1 = new XColumnContainerColumn();
    let col2 = new XColumnContainerColumn();
    col2.interControlSpacing = 20;

    container.add(col1);
    container.add(col2);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "Large Size";
    col1.add(label);

    let datePicker = new DatePickerFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.valueName = "value";
    datePicker.requiredOnAllOutcomes = false;
    col1.add(datePicker);

    datePicker = new DatePickerFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.OUTLINE;
    datePicker.valueName = "value";
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col1.add(datePicker);

    datePicker = new DatePickerFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.SHADED;
    datePicker.valueName = "value";
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col1.add(datePicker);

    datePicker = new DatePickerFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.valueName = "value";
    datePicker.style = TextControlStyle.UNDERLINED;
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col1.add(datePicker);

    label = new LabelFormControl();
    label.text = "Small Size";
    col2.add(label);

    datePicker = new DatePickerFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.valueName = "value";
    datePicker.requiredOnAllOutcomes = false;
    datePicker.size = TextControlSize.SMALL;
    col2.add(datePicker);

    datePicker = new DatePickerFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.OUTLINE;
    datePicker.valueName = "value";
    datePicker.size = TextControlSize.SMALL;
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col2.add(datePicker);

    datePicker = new DatePickerFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.SHADED;
    datePicker.valueName = "value";
    datePicker.size = TextControlSize.SMALL;
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col2.add(datePicker);

    datePicker = new DatePickerFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.UNDERLINED;
    datePicker.valueName = "value";
    datePicker.size = TextControlSize.SMALL;
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col2.add(datePicker);

    return { form: ui };
}

export const DatePickerStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Picker",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DatePickerFormControl;
                if (ctf) {
                    ctf.hintText = "hint text";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Picker",
        "With Hint",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DatePickerFormControl;
                if (ctf) {
                    ctf.placeholderText = "placeholder text";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Picker",
        "With Placeholder",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DatePickerFormControl;
                if (ctf) {
                    ctf.requiredOnAllOutcomes = true;
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Picker",
        "With Validation",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values["value"] = "2000-01-01";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Date Picker",
        "From Data",
    ),
];
